module.exports = __webpack_public_path__ + "img/target.f0c589d6.svg";